<template>
  <div>
    <h3>Informations sur le compte</h3>

    <br/>

    <b-form-row>
      <b-col>
        <b-form-group label="Adresse courriel">
          <b-form-input
              v-model="user.email"
              type="email"
              :state="validateState('email')"
              aria-describedby="input-email-feedback"
              @input="setField('email', $event)"
          />
          <b-form-invalid-feedback id="input-email-feedback">
            Veuillez entrer une adresse courriel valide
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Confirmation de l'adresse courriel">
          <b-form-input
              v-model="user.emailConfirmation"
              type="email"
              :state="validateState('emailConfirmation')"
              aria-describedby="input-email-confirm-feedback"
              @input="setField('emailConfirmation', $event)"
          />
          <b-form-invalid-feedback id="input-email-confirm-feedback">
            <template v-if="!$v.user.emailConfirmation.required || !$v.user.emailConfirmation.email">
              Veuillez entrer une adresse courriel valide
            </template>
            <template v-else-if="!$v.user.emailConfirmation.sameAs">
              La confirmation de l'adresse courriel doit être identique à l'adresse courriel.
            </template>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-form-row>

    <b-form-row>
      <b-col>
        <b-form-group label="Mot de passe">
          <b-form-input
              v-model="user.password"
              :disable-strength="true"
              class="form-control"
              type="password"
              :state="validateState('password')"
              aria-describedby="input-password-feedback"
              @input="setField('password', $event)"
              ref="password"
          />
          <password-toggle :input="$refs['password']" />
          <b-form-invalid-feedback id="input-password-feedback">
            <template v-if="!$v.user.password.required || !$v.user.password.minLength">
              Votre mot de passe doit contenir un minimum de 6 caractères.
            </template>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Confirmation du mot de passe">
          <b-form-input
              v-model="user.passwordConfirmation"
              type="password"
              :state="validateState('passwordConfirmation')"
              aria-describedby="input-password-confirm-feedback"
              @input="setField('passwordConfirmation', $event)"
              ref="password-confirmation"
          />
          <password-toggle :input="$refs['password-confirmation']" />
          <b-form-invalid-feedback id="input-password-confirm-feedback">
            <template v-if="!$v.user.passwordConfirmation.required || !$v.user.passwordConfirmation.minLength">
              Votre mot de passe doit contenir un minimum de 6 caractères.
            </template>
            <template v-else-if="!$v.user.passwordConfirmation.sameAs">
              La confirmation du mot de passe doit être identique au mot de passe.
            </template>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-form-row>

    <address-form-v2 :address="user.address" ref="address"/>

    <b-form-row>
        <b-col>
            <b-form-group label="Comment avez-vous entendu parler du COQ ?">
                <b-form-select v-model="user.isFrom">
                    <b-form-select-option value="facebook">Facebook</b-form-select-option>
                    <b-form-select-option value="search">Site Internet (recherche Google)</b-form-select-option>
                    <b-form-select-option value="event">À un événement où le Club était présent</b-form-select-option>
                    <b-form-select-option value="member">Par un ou une membre du COQ</b-form-select-option>
                    <b-form-select-option value="other">Autre</b-form-select-option>
                </b-form-select>
            </b-form-group>
        </b-col>
        <b-col>
            <b-form-group label="Veuillez préciser" v-if="user.isFrom === 'other'">
                <b-form-input
                    v-model="user.isFromOther"
                    :state="validateState('isFromOther')"
                    aria-describedby="input-is-from-other-feedback"
                />
                <b-form-invalid-feedback :force-show="!$v.user.isFromOther.required || !$v.user.isFromOther.minLength">
                  Veuillez entrer comment avez-vous entendu parler du COQ.
                </b-form-invalid-feedback>
            </b-form-group>
        </b-col>
    </b-form-row>

  </div>
</template>

<script>
  import AddressFormV2 from '../Utilisateurs/Utilisateur_Formulaire_Adresse';
  import PasswordToggle from '@/components/inputs/password-toggle';
  const { required, requiredIf, minLength, email, sameAs } = require('vuelidate/lib/validators');

  export default {
    name: 'register-user',
    props: {
      user: {
        type: Object
      }
    },
    components: { PasswordToggle, AddressFormV2 },
    validations: {
      user: {
        email: {
          required,
          email
        },
        emailConfirmation: {
          required,
          email,
          sameAs: sameAs('email')
        },
        password: {
          required,
          minLength: minLength(6)
        },
        passwordConfirmation: {
          required,
          sameAs: sameAs('password'),
          minLength: minLength(6)
        },
        isFromOther: {
          required: requiredIf((m) => {
            return m.isFrom === 'other';
          }),
          minLength: minLength(2)
        }
      }
    },
    methods: {
      validateState(name) {
        const { $dirty, $error } = this.$v.user[name];
        return $dirty ? !$error : null;
      },
      setField(field, street) {
        this.user[field] = street;
        this.$v.user[field].$touch();
      },
      check() {
        this.$v.user.$touch();
        this.$refs.address.$v.$touch();
        return !(this.$v.user.$anyError || this.$refs.address.$v.$anyError);
      }
    }
  };
</script>

<style scoped></style>
